import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import { readableNumberParts } from '../../../helpers/Numbers';
import { readableDate } from '../../../helpers/Date';
const InvoiceTableRow = ({ invoice, noHover }) => {
    return (_jsxs(TableRow, { noHover: noHover, children: [_jsx(TableCell, { label: "Factuurnr.", value: invoice.id }), _jsx(TableCell, { label: "Datum", value: readableDate(invoice.date) }), _jsx(TableCell, { label: "Vervaldatum", value: readableDate(invoice.date_deadline) }), _jsx(TableCell, { label: "Omschrijving", value: invoice.description }), _jsx(TableCell, { label: "Bedrag", value: readableNumberParts(invoice.amount, 'EUR').long })] }));
};
export default InvoiceTableRow;
